import { render } from "./LoadingSpinnerRedirect.vue?vue&type=template&id=93b306aa&scoped=true"
const script = {}

import "./LoadingSpinnerRedirect.vue?vue&type=style&index=0&id=93b306aa&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b306aa"]])

export default __exports__